<div class="obg-m-hgc-session-limit-header">
	<img obgImageContent="general.session-limit-time" />
	<div>
		<h1>{{ 'hgc.multi-session-limit.title' | translate }}</h1>
		<p>{{ 'hgc.multi-session-limit.description' | translate }}</p>
	</div>
</div>

<div class="obg-m-hgc-session-limit-queued-notification" *ngIf="upcomingSessionLimit">
	<span class="notification-icon ico-exclamation"></span>
	<label
		[innerHTML]="'hgc.multi-session-limit.upcoming-limit.' + (upcomingSessionLimit.limitPeriod | lowercase) | translate: {
				queuedLimit: upcomingSessionLimit.limitValue,
				activeFrom: upcomingSessionLimit.activeFrom | date: 'dd MMMM yyyy'
			}"
		test-id="upcoming-limit"
	>
	</label>
</div>

<mat-card class="obg-m-hgc-session-limit-container">
	<h2>{{ 'hgc.multi-session-limit.title' | translate }}</h2>
	<div>
		<span>{{ 'hgc.multi-session-limit.current-limit' | translate }}</span>
		<span
			class="obg-m-hgc-session-limit-amount"
			*ngIf="currentSessionLimit; else noLimit"
			[innerHTML]="'hgc.multi-session-limit.current-limit.' + (currentSessionLimit.limitPeriod | lowercase) | translate: {
				limit: currentSessionLimit.limitValue
			}"
		>
		</span>

		<ng-template #noLimit>
			<span>{{ "general.not-set" | translate }}</span>
		</ng-template>
	</div>
	<div class="btn-container" *ngIf="!isSessionLimitEdited">
		<button mat-flat-button color="primary" (click)="editSessionLimit()" [disabled]="isSettingBusy">
			<mat-spinner *ngIf="isSettingBusy; else showContent" diameter="20"></mat-spinner>
			<ng-template #showContent>{{ 'hgc.multi-session-limit.change-session-limit' | translate }}</ng-template>
		</button>
	</div>
</mat-card>
<mat-card class="obg-m-hgc-session-limit-edit" *ngIf="isSessionLimitEdited">
	<form [formGroup]="formGroup" #form="ngForm" (ngSubmit)="submitSessionLimit()">
		<h2>{{ 'responsible-gaming.enter-session-time-limits' | translate }}:</h2>

		<mat-radio-group formControlName="sessionLimitPeriod">
			<mat-radio-button [value]="sessionLimitPeriodControls.Daily" [checked]="true" color="primary"
				>{{ 'hgc.multi-session-limit.daily' | translate }}</mat-radio-button
			>
			<mat-radio-button [value]="sessionLimitPeriodControls.Weekly" color="primary"
				>{{ 'hgc.multi-session-limit.weekly' | translate }}</mat-radio-button
			>
			<mat-radio-button [value]="sessionLimitPeriodControls.Monthly" color="primary"
				>{{ 'hgc.multi-session-limit.monthly' | translate }}</mat-radio-button
			>
		</mat-radio-group>

		<mat-form-field floatLabel="always">
			<mat-label>{{ 'hgc.multi-session-limit.label' | translate }}</mat-label>
			<input
				matInput
				type="tel"
				[placeholder]="placeholder"
				formControlName="sessionLimitAmount"
				obgNumericNotZero
				required
			/>
		</mat-form-field>

		<obg-common-validation-renderer
			[input]="formGroup.controls.sessionLimitAmount"
			translationPrefix="hgc.multi-session-limit"
		>
		</obg-common-validation-renderer>

		<div class="btn-container">
			<button mat-flat-button color="primary" type="submit" [disabled]="!formGroup.valid">
				{{ 'hgc.multi-session-limit.set-session-time-limits' | translate }}
			</button>
		</div>
	</form>
</mat-card>

<div class="caption" [innerHtml]="'hgc.multi-session-limit.information'| translate"></div>
